import React from "react";

const URL404 = () => (
    <main id="main-content">
        <h1>404 Error</h1>
        <p><code>{window.location.pathname}</code> is not a valid URL.</p>
        <p><a href="/">Return to home page</a></p>
    </main>
);

export default URL404;